// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3ps9p","title":"style_title__3JCsH","testimonials-container":"style_testimonials-container__1ZW7h"};